import React from 'react';
import { Button } from '@mui/material';

/**
 * A customizable power button component.
 *
 * @param {string} text - The text to display on the button.
 * @param {string} [variant='outlined'] - The variant of the button. Can be 'outlined', 'contained', or 'text'.
 * @param {string} [color='primary'] - The color of the button. Can be 'primary', 'secondary', 'error', 'warning', 'info', or 'success'.
 * @param {function} onClick - The function to call when the button is clicked.
 *
 *
 * @returns {React.ReactElement} A React element representing the power button.
 */
const PowerButton = ({ text, variant = 'outlined', color = 'primary', onClick, selected }) => {
  return (
    <Button
      size="small"
      variant={variant}
      color={color}
      onClick={onClick}
     sx={{
        fontFamily: 'Open Sans',
         color: selected ? '#fff' : '#363636',
        width: { xs: '100%', sm: '100%', md: '90%' },
        height: { xs: 'auto', sm: '40px' },
        padding: '10px 20px',
        margin: '0 10px',
        textTransform: 'none',
        whiteSpace: 'normal',  
        wordWrap: 'break-word', 
        overflow: 'hidden', 
        fontSize:'16px'
      }}
    
    >
      {text}
    </Button>
  );
};
export default PowerButton;